<template>
  <div>
    <v-row justify="start" align="start">
      <v-col cols="12">
        <v-card color="background" flat>
          <v-card-title>Order Confirmed</v-card-title>
          <v-card-text>
            <div>Transaction ID: {{ transaction.td_id }}</div>
            <div>
              Order Reference:
              {{ transaction.cust_ref ? transaction.cust_ref : "N/A" }}
            </div>
          </v-card-text>

          <v-card-text>
            Ticket Numbers
            <div v-for="(ticket, index) in transaction.ticketNos" :key="index">
              <b>{{ ticket }}</b>
            </div>
          </v-card-text>
               <!-- this will hide the total vat and total price  -->
          <v-card-text v-if="$store.getters.retrieveShowPrices">
            <div>
              Order Total:
              <b>
                {{ parseFloat(transaction.orderTotal).toFixed(2) }}
              </b>
            </div>
            <div>
              VAT Total:
              <b>
                {{ parseFloat(transaction.vatTotal).toFixed(2) }}
              </b>
            </div>
          </v-card-text>

          <v-card-text class="confirmationText">
            <b>{{ orderConfirmationMessage }}</b>
          </v-card-text>
          <v-card-actions>
            <v-btn
              exact
              block
              color="blue darken-2"
              class="white--text"
              outlined
              large
              :to="{ name: 'Home' }"
            >
              <v-icon class="mr-2">home</v-icon>Home
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["transaction"],

  activated() {
    console.log(this.transaction);
  },

  computed: {
    orderConfirmationMessage() {
      if (this.$store.getters.retrieveAllConfigs.order_confirmation_message) {
        return this.$store.getters.retrieveAllConfigs
          .order_confirmation_message;
      } else {
        return "Thank you for your order";
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~vuetify/src/styles/styles.sass'

.confirmationText
  color: var(--v-error-darken2) !important
</style>